<template>
  <div class="device-overview-container">
    <div class="device-overview-panel">
    <header class="device-header">
      <div class="header-title">
        <div class="eyebrow">Device Data</div>
        <h1>控制器数据</h1>
      </div>
      <el-row class="tab-nav-list">
        <el-col
          v-for="(item, index) in optMenus"
          :key="index"
          :class="selectIndex == index ? 'tab-item active' : 'tab-item'"
          @click.native="changeTab(index)"
        >
          {{ item }}
        </el-col>
      </el-row>
    </header>

    <management-table
      v-if="selectIndex == 0"
      title="控制器实时数据"
      embedded
      table-class="device-one-table"
      :data="tableData"
      :loading="loading"
      :current-page="query.pageNum"
      :page-size="query.pageSize"
      :total="total"
      empty-text="暂无实时数据"
      @current-change="onPageChange"
    >
      <template slot="filters">
        <div class="search-item">
          <label class="search-label">电站名称:</label>
          <el-select
            v-model="query.stationId"
            class="search-select"
            clearable
            filterable
            :filter-method="filterStation"
            @visible-change="onStationDropdownVisible"
            placeholder="请选择或输入电站名称"
          >
            <el-option
              v-for="item in stationList"
              :label="item.stationName"
              :key="item.id"
              :value="item.id"
            />
          </el-select>
        </div>
        <div class="search-item">
          <label class="search-label">控制器选择:</label>
          <el-select
            v-model="query.id"
            class="search-select"
            clearable
            filterable
            placeholder="请选择控制器"
          >
            <el-option
              v-for="item in deviceList"
              :label="item.deviceName"
              :key="item.id"
              :value="item.id"
            />
          </el-select>
        </div>
      </template>

      <template slot="actions">
        <el-button type="primary" icon="el-icon-search" class="search-btn" @click="serch">搜索</el-button>
      </template>

      <template slot="columns">
          <el-table-column
            type="index"
            fixed="left"
            width="50"
            label="序号"
            align="center"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            width="100"
            label="电站名称"
            prop="stationName"
            align="center"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            width="100"
            label="控制器"
            prop="deviceName"
            align="center"
          >
          </el-table-column>
          <el-table-column
            width="100"
            label="工作状态"
            prop="workStatus"
            align="center"
          >
          </el-table-column>
          <el-table-column
            width="100"
            label="故障"
            prop="errcode"
            align="center"
          >
          </el-table-column>
          <el-table-column width="120" label="光伏输入电压1" align="center">
            <template slot-scope="scope">{{ scope.row.pvInVolCh1 }}V</template>
          </el-table-column>
          <el-table-column width="120" label="光伏输入电压2" align="center">
            <template slot-scope="scope">{{ scope.row.pvInVolCh2 }}V</template>
          </el-table-column>
          <el-table-column width="120" label="光伏输入电压3" align="center">
            <template slot-scope="scope">{{ scope.row.pvInVolCh3 }}V</template>
          </el-table-column>
          <el-table-column width="120" label="光伏输入电压4" align="center">
            <template slot-scope="scope">{{ scope.row.pvInVolCh4 }}V</template>
          </el-table-column>
          <el-table-column width="120" label="模组1输出电流" align="center">
            <template slot-scope="scope">{{ scope.row.pvOutCurCh1 }}A</template>
          </el-table-column>
          <el-table-column width="120" label="模组2输出电流" align="center">
            <template slot-scope="scope">{{ scope.row.pvOutCurCh2 }}A</template>
          </el-table-column>
          <el-table-column width="120" label="模组3输出电流" align="center">
            <template slot-scope="scope">{{ scope.row.pvOutCurCh3 }}A</template>
          </el-table-column>
          <el-table-column width="120" label="模组4输出电流" align="center">
            <template slot-scope="scope">{{ scope.row.pvOutCurCh4 }}A</template>
          </el-table-column>
          <el-table-column width="100" label="输出电压" align="center">
            <template slot-scope="scope">{{ scope.row.pvOutVol }}V</template>
          </el-table-column>
          <el-table-column width="100" label="输出总电流" align="center">
            <template slot-scope="scope"
              >{{ scope.row.pvOutCurTotal }}A</template
            >
          </el-table-column>
          <el-table-column width="100" label="输出总电压" align="center">
            <template slot-scope="scope"
              >{{ scope.row.pvOutVolTotal }}V</template
            >
          </el-table-column>
          <el-table-column width="100" label="负载电压" align="center">
            <template slot-scope="scope">{{ scope.row.loadVol }}V</template>
          </el-table-column>
          <el-table-column width="100" label="负载电流" align="center">
            <template slot-scope="scope">{{ scope.row.loadcur }}A</template>
          </el-table-column>
          <el-table-column width="100" label="负载功率" align="center">
            <template slot-scope="scope">{{ scope.row.loadPower }}KW</template>
          </el-table-column>
          <el-table-column width="100" label="电池温度" align="center">
            <template slot-scope="scope">{{ scope.row.tempBat }}°C</template>
          </el-table-column>
          <el-table-column width="100" label="内部温度" align="center">
            <template slot-scope="scope"
              >{{ scope.row.tempInternal }}°C</template
            >
          </el-table-column>
          <el-table-column width="100" label="CO2减排" align="center">
            <template slot-scope="scope">{{ scope.row.co2 }}Kg</template>
          </el-table-column>
          <el-table-column
            width="160"
            label="数据时间"
            prop="uploadTime"
            align="center"
          >
          </el-table-column>
          <el-table-column width="50" fixed="right" label="操作" align="center">
            <template slot-scope="scope">
              <span
                class="table-operate"
                @click="
                  formObject = scope.row;
                  showInfo = true;
                "
                >查看</span
              >
            </template>
          </el-table-column>
      </template>
    </management-table>

    <el-dialog
        v-if="selectIndex == 0"
        title="数据详情"
        :visible.sync="showInfo"
        @close="showInfo = false"
        width="850px"
        class="custom-dialog"
      >
        <div class="dialog-content">
          <el-row class="dialog-item">
            <el-col :span="12">
              <div class="dialog-label">电站名称：</div>
              <div class="dialog-value">{{ formObject.stationName }}</div>
            </el-col>
            <el-col :span="12">
              <div class="dialog-label">控制器：</div>
              <div class="dialog-value">{{ formObject.deviceName }}</div>
            </el-col>
          </el-row>
          <el-row class="dialog-item">
            <el-col :span="12">
              <div class="dialog-label">工作状态：</div>
              <div class="dialog-value">{{ formObject.workStatus }}</div>
            </el-col>
            <el-col :span="12">
              <div class="dialog-label">故障：</div>
              <div class="dialog-value">{{ formObject.errcode }}</div>
            </el-col>
          </el-row>
          <el-row class="dialog-item">
            <el-col :span="12">
              <div class="dialog-label">光伏输入电压1：</div>
              <div class="dialog-value">{{ formObject.pvInVolCh1 }}V</div>
            </el-col>
            <el-col :span="12">
              <div class="dialog-label">光伏输入电压2：</div>
              <div class="dialog-value">{{ formObject.pvInVolCh2 }}V</div>
            </el-col>
          </el-row>
          <el-row class="dialog-item">
            <el-col :span="12">
              <div class="dialog-label">光伏输入电压3：</div>
              <div class="dialog-value">{{ formObject.pvInVolCh3 }}V</div>
            </el-col>
            <el-col :span="12">
              <div class="dialog-label">光伏输入电压4：</div>
              <div class="dialog-value">{{ formObject.pvInVolCh4 }}V</div>
            </el-col>
          </el-row>
          <el-row class="dialog-item">
            <el-col :span="12">
              <div class="dialog-label">模组1输出电流：</div>
              <div class="dialog-value">{{ formObject.pvOutCurCh1 }}A</div>
            </el-col>
            <el-col :span="12">
              <div class="dialog-label">模组2输出电流：</div>
              <div class="dialog-value">{{ formObject.pvOutCurCh2 }}A</div>
            </el-col>
          </el-row>
          <el-row class="dialog-item">
            <el-col :span="12">
              <div class="dialog-label">模组3输出电流：</div>
              <div class="dialog-value">{{ formObject.pvOutCurCh3 }}A</div>
            </el-col>
            <el-col :span="12">
              <div class="dialog-label">模组4输出电流：</div>
              <div class="dialog-value">{{ formObject.pvOutCurCh4 }}A</div>
            </el-col>
          </el-row>
          <el-row class="dialog-item">
            <el-col :span="12">
              <div class="dialog-label">输出电压：</div>
              <div class="dialog-value">{{ formObject.pvOutVol }}V</div>
            </el-col>
            <el-col :span="12">
              <div class="dialog-label">充电总电流：</div>
              <div class="dialog-value">{{ formObject.pvOutCurTotal }}A</div>
            </el-col>
          </el-row>
          <el-row class="dialog-item">
            <el-col :span="12">
              <div class="dialog-label">输出总电压：</div>
              <div class="dialog-value">{{ formObject.pvOutVolTotal }}V</div>
            </el-col>
            <el-col :span="12">
              <div class="dialog-label">均充功率：</div>
              <div class="dialog-value">{{ formObject.pvOutPowerTotal }}KW</div>
            </el-col>
          </el-row>
          <el-row class="dialog-item">
            <el-col :span="12">
              <div class="dialog-label">负载电压：</div>
              <div class="dialog-value">{{ formObject.loadVol }}V</div>
            </el-col>
            <el-col :span="12">
              <div class="dialog-label">负载电流：</div>
              <div class="dialog-value">{{ formObject.loadcur }}A</div>
            </el-col>
          </el-row>
          <el-row class="dialog-item">
            <el-col :span="12">
              <div class="dialog-label">负载功率：</div>
              <div class="dialog-value">{{ formObject.loadPower }}KW</div>
            </el-col>
            <el-col :span="12">
              <div class="dialog-label">电池温度：</div>
              <div class="dialog-value">{{ formObject.tempBat }}°C</div>
            </el-col>
          </el-row>
          <el-row class="dialog-item">
            <el-col :span="12">
              <div class="dialog-label">内部温度：</div>
              <div class="dialog-value">{{ formObject.tempInternal }}°C</div>
            </el-col>
            <el-col :span="12">
              <div class="dialog-label">CO2减排：</div>
              <div class="dialog-value">{{ formObject.co2 }}Kg</div>
            </el-col>
          </el-row>
          <el-row class="dialog-item">
            <el-col :span="12">
              <div class="dialog-label">数据时间：</div>
              <div class="dialog-value">{{ formObject.uploadTime }}</div>
            </el-col>
          </el-row>
        </div>
    </el-dialog>

    <!-- 嵌套子组件：保留原传参逻辑，样式由子组件自身统一 -->
    <deviceOneOnLineVue v-if="selectIndex == 1" :id="query.id" />
    <deviceOneChongDian v-if="selectIndex == 2" :id="query.id" />
    <deviceOneDianChiVueVue v-if="selectIndex == 3" :id="query.id" />
    </div>
  </div>
</template>

<script>
// 导入子组件（路径保持不变）
import deviceOneOnLineVue from "./deviceOneOnLine.vue";
import deviceOneChongDian from "./deviceOneChongDian.vue";
import deviceOneDianChiVueVue from "./deviceOneDianChiVue.vue";
import ManagementTable from "../../components/ManagementTable.vue";

export default {
  name: "DeviceOne",
  components: {
    deviceOneOnLineVue,
    deviceOneChongDian,
    deviceOneDianChiVueVue,
    ManagementTable,
  },
  props: {
    id: {
      required: false,
      type: Number,
    },
  },
  data() {
    return {
      showInfo: false, // 详情弹窗显示状态
      formObject: {}, // 弹窗详情数据
      tableData: [], // 实时数据表格
      total: 0, // 表格总条数
      loading: false,
      query: {
        // 查询参数
        pageNum: 1,
        pageSize: 9,
        deviceType: 1,
        id: null,
        stationId: null,
      },
      deviceList: [], // 设备下拉列表
      allStationList: [],
      stationList: [],
      selectIndex: 0, // 当前选中标签索引
      optMenus: ["实时数据", "运行数据", "充电数据", "电池数据"], // 标签菜单
    };
  },
  mounted() {
    // 父组件传参赋值控制器ID
    if (this.id != null) this.query.id = this.id;
    // 初始化加载电站、设备列表和实时数据
    this.loadStationList();
    this.loadAllList();
    this.loadPage();
  },
  methods: {
    changeTab(index) {
      this.selectIndex = index;
    },
    // 分页切换：更新页码并加载数据
    onPageChange(val) {
      this.query.pageNum = val;
      this.loadPage();
    },
    // 搜索查询：重置页码为1并加载数据
    serch() {
      this.query.pageNum = 1;
      this.loadPage();
    },
    // 加载实时数据分页
    loadPage() {
      this.loading = true;
      this.$request
        .post("/api/device/gf/last/page", this.query)
        .then((response) => {
          if (response.data.result) {
            this.tableData = response.data.data.list;
            this.total = response.data.data.totalCount;
          } else {
            this.$Message.error("获取实时数据失败,请联系管理员!");
          }
        })
        .catch((err) => {
          // 补充网络异常捕获
          this.$Message.error("网络异常，获取实时数据失败！");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    loadStationList() {
      this.$request.get("/api/power/station/options").then((response) => {
        if (response.data.result) {
          this.allStationList = response.data.data || [];
          this.stationList = this.allStationList.slice();
        } else {
          this.$Message.error("获取电站列表失败,请联系管理员!");
        }
      }).catch(() => {
        this.$Message.error("网络异常，获取电站列表失败！");
      });
    },
    filterStation(query) {
      const keyword = String(query || "").trim().toLocaleLowerCase();
      this.stationList = keyword ? this.allStationList.filter((item) =>
        String(item.stationName || "").toLocaleLowerCase().includes(keyword)
      ) : this.allStationList.slice();
    },
    onStationDropdownVisible(visible) {
      if (visible) this.stationList = this.allStationList.slice();
    },
    // 两个数据页面共用完整设备列表
    loadAllList() {
      let queryForm = { pageNum: 1, pageSize: 10000 };
      this.$request
        .post("/api/device/page", queryForm)
        .then((response) => {
          if (response.data.result) {
            this.deviceList = response.data.data.list;
          } else {
            this.$Message.error("获取设备列表失败,请联系管理员!");
          }
        })
        .catch((err) => {
          // 补充网络异常捕获
          this.$Message.error("网络异常，获取设备列表失败！");
        });
    },
  },
};
</script>

<style scoped>
.device-overview-container {
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow: hidden;
  box-sizing: border-box;
  background: linear-gradient(135deg, rgba(var(--solar-primary-rgb, 0, 153, 255), 0.08), transparent 34%), var(--solar-page, #001a33);
}

.device-overview-panel {
  --device-content-gutter: 22px;
  width: 100%;
  height: 100%;
  max-height: 100%;
  min-height: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid rgba(var(--solar-border-strong-rgb, 63, 184, 255), 0.45);
  border-radius: 8px;
  background: rgba(var(--solar-page-rgb, 0, 31, 61), 0.92);
  box-shadow: 0 18px 40px rgba(0, 7, 18, 0.32), inset 0 1px 0 rgba(176, 226, 255, 0.18);
  box-sizing: border-box;
}

.device-header {
  flex: 0 0 auto;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px var(--device-content-gutter) 14px;
  border-bottom: 1px solid rgba(var(--solar-border-strong-rgb, 63, 184, 255), 0.28);
  background: linear-gradient(90deg, rgba(var(--solar-surface-rgb, 0, 43, 77), 0.92), rgba(var(--solar-page-rgb, 0, 26, 51), 0.72));
}

.header-title {
  flex: 0 0 auto;
}

.eyebrow {
  color: var(--solar-text, #7bdff2);
  font-size: 12px;
  line-height: 18px;
  text-transform: uppercase;
}

.device-header h1 {
  margin: 2px 0 0;
  color: var(--solar-text-strong, #effcff);
  font-size: 24px;
  line-height: 32px;
  font-weight: 700;
}

.tab-nav-list {
  flex: 1 1 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  min-width: 0;
  margin: 0;
}

/* Element UI 的 el-row 会生成清除浮动伪元素；在 flex + gap 下会形成尾部空隙。 */
.tab-nav-list::before,
.tab-nav-list::after {
  display: none;
}

.tab-item {
  width: 112px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  border: 1px solid var(--solar-border, #003c66);
  border-radius: 4px;
  background-color: var(--solar-surface, #002b4d);
  color: var(--solar-text, #87cefa);
  cursor: pointer;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.tab-item.active {
  border-color: var(--solar-border-strong, #0099ff);
  background-color: var(--solar-primary, #0099ff);
  color: var(--solar-on-primary, #002b4d);
}

.tab-item:hover:not(.active) {
  border-color: var(--solar-border-strong, #0099ff);
  background-color: var(--solar-raised, #003c66);
  color: var(--solar-text-strong, #b0e2ff);
}

.table-operate {
  color: var(--solar-primary, #00ccff);
  font-size: 14px;
  cursor: pointer;
  transition: color 0.3s ease;
}

.table-operate:hover {
  color: var(--solar-primary, #0099ff);
  text-decoration: underline;
}

/deep/ .custom-dialog .el-dialog {
  border: 1px solid var(--solar-border, #003c66);
  border-radius: 8px;
  background: var(--solar-surface, #002b4d);
  box-shadow: 0 18px 48px rgba(0, 7, 18, 0.5);
  overflow: hidden;
}

/deep/ .custom-dialog .el-dialog__header {
  padding: 18px 52px 18px 22px;
  border-bottom: 1px solid var(--solar-border, #003c66);
  background-color: var(--solar-page, #001a33);
}

/deep/ .custom-dialog .el-dialog__body {
  padding: 16px 22px 20px;
  background-color: var(--solar-surface, #002b4d);
}

/deep/ .custom-dialog .el-dialog__title,
/deep/ .custom-dialog .el-dialog__close {
  color: var(--solar-text, #87cefa);
}

/deep/ .custom-dialog .el-dialog__close:hover {
  color: var(--solar-primary, #00ccff);
}

.dialog-content {
  padding: 0;
}

.dialog-item {
  display: flex;
  align-items: stretch;
  margin: 0;
  color: var(--solar-text, #87cefa);
}

.dialog-item > .el-col {
  min-width: 0;
  display: flex;
  align-items: flex-start;
  padding: 12px 14px;
  border-bottom: 1px solid rgba(var(--solar-border-strong-rgb, 63, 184, 255), 0.14);
}

.dialog-label {
  flex: 0 0 130px;
  color: var(--solar-text, #87cefa);
  font-size: 14px;
  line-height: 22px;
}

.dialog-value {
  min-width: 0;
  color: var(--solar-text-strong, #fff);
  font-size: 14px;
  line-height: 22px;
  overflow-wrap: anywhere;
}

/* 页签与查询栏共用同一条右边界，避免两组操作入口出现视觉错位。 */
/deep/ .management-table-search {
  padding-right: var(--device-content-gutter);
  padding-left: var(--device-content-gutter);
}

/* DevTools 停靠或低高度窗口下压缩非数据区域，始终保留完整头部。 */
@media (max-height: 720px) {
  .device-overview-container {
    padding-top: 12px;
    padding-bottom: 12px;
  }

  .device-header {
    padding-top: 8px;
    padding-bottom: 8px;
  }

  .eyebrow {
    display: none;
  }

  .device-header h1 {
    margin-top: 0;
    font-size: 20px;
    line-height: 28px;
  }

  .tab-item {
    height: 32px;
    line-height: 32px;
  }

  /deep/ .management-table-search {
    padding-top: 8px;
    padding-bottom: 8px;
  }

  /deep/ .management-table-panel {
    padding-top: 10px;
  }

  /deep/ .management-table-pager {
    min-height: 44px;
    padding-top: 6px;
    padding-bottom: 6px;
  }
}

@media (max-width: 760px) {
  /* 移动端覆盖式滚动条会让 Element UI 的右侧固定列产生细小漏底缝隙。 */
  /deep/ .device-one-table .el-table__fixed-right {
    right: 0 !important;
    background-color: var(--solar-surface, #002b4d) !important;
  }

  /deep/ .device-one-table .el-table__fixed-right::after {
    position: absolute;
    z-index: 4;
    top: 0;
    right: -1px;
    bottom: 0;
    width: 2px;
    background-color: var(--solar-surface, #002b4d);
    content: '';
    pointer-events: none;
  }

  .device-overview-container {
    padding: 8px;
  }

  .device-overview-panel {
    --device-content-gutter: 10px;
  }

  .device-header {
    align-items: stretch;
    flex-direction: column;
    gap: 8px;
    padding-top: 9px;
    padding-bottom: 9px;
  }

  .eyebrow {
    font-size: 10px;
    line-height: 14px;
  }

  .device-header h1 {
    margin-top: 0;
    font-size: 18px;
    line-height: 26px;
  }

  .tab-nav-list {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 6px;
  }

  .tab-item {
    width: auto;
    min-width: 0;
    height: 34px;
    line-height: 34px;
  }

  /deep/ .custom-dialog .el-dialog {
    width: calc(100vw - 24px) !important;
    max-height: calc(100vh - 24px);
    max-height: calc(100dvh - 24px);
    margin: 12px auto !important;
    display: flex;
    flex-direction: column;
  }

  /deep/ .custom-dialog .el-dialog__header {
    flex: 0 0 auto;
    padding: 15px 48px 15px 16px;
  }

  /deep/ .custom-dialog .el-dialog__headerbtn {
    top: 16px;
    right: 16px;
  }

  /deep/ .custom-dialog .el-dialog__body {
    min-height: 0;
    padding: 6px 16px 14px;
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
  }

  .dialog-item {
    display: block;
  }

  .dialog-item > .el-col-12 {
    width: 100%;
    float: none;
    display: grid;
    grid-template-columns: minmax(104px, 40%) minmax(0, 1fr);
    gap: 10px;
    padding: 11px 0;
  }

  .dialog-label {
    width: auto;
    min-width: 0;
  }
}
</style>
